import { DashboardTrendPoint } from '../../services/dashboardApi';

type TrendBarChartProps = {
  title: string;
  points: DashboardTrendPoint[];
};

function formatDay(value: string): string {
  const date = new Date(value);
  return Number.isNaN(date.getTime())
    ? value
    : date.toLocaleDateString('pt-BR', { weekday: 'short', day: '2-digit' });
}

export function TrendBarChart({ title, points }: TrendBarChartProps) {
  const max = Math.max(...points.map((point) => point.count), 1);

  return (
    <div className="rounded-xl border border-secondary-200 bg-white p-5">
      <h3 className="font-semibold text-secondary-900">{title}</h3>
      <div className="mt-6 flex items-end gap-2 h-40">
        {points.map((point) => (
          <div key={point.date} className="flex flex-1 flex-col items-center gap-2">
            <span className="text-xs font-medium text-secondary-700">{point.count}</span>
            <div
              className="w-full rounded-t-md bg-primary-500"
              style={{ height: `${Math.max(8, (point.count / max) * 100)}%` }}
            />
            <span className="text-[10px] text-secondary-500">{formatDay(point.date)}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
